// Extra opt-in add-ons that sit outside the upsell groups, such as the matching protector box on the
// mattress page (sections/mj-mattress-product.liquid, October 2026). assets/mj-mattress.js only shows
// that box when this flag is set, so a shopper is never offered something this script wouldn't add.
window.mjAddonExtrasSupported = true;

document.addEventListener("DOMContentLoaded", function () {
  // ============================================================================
  // GLOBAL STATE & INITIALIZATION
  // ============================================================================

  const addonGroupsNew = new Map();
  let currentVariantTitle = null;

  const drawerTriggers = document.querySelectorAll(".drawer-trigger-new");
  const simpleGroups = document.querySelectorAll(".simple-addon-group-new");
  const allDrawerOverlays = document.querySelectorAll(".drawer-overlay-new");

  const mainAddToCartBtn = document.querySelector('button[name="add"]');
  const mainProductForm = document.querySelector(
    'form[data-type="add-to-cart-form"]'
  );
  const variantSelectors = document.querySelectorAll(
    'input[name*="Size"], select[name*="Size"], input[name*="options"], select[name*="options"]'
  );

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  // Ticked extras outside the upsell groups: input[data-mj-addon-extra] with data-variant-id,
  // data-price (pence), data-title, data-size, data-image, data-category-title, data-upsell-source.
  // Hidden boxes never count. Kept for the "Added to Cart" pop-up after the boxes are unticked.
  let lastMjExtras = [];
  function getMjExtraAddons() {
    return Array.from(
      document.querySelectorAll("input[data-mj-addon-extra]:checked")
    )
      .filter((input) => input.dataset.variantId && !input.closest("[hidden]"))
      .map((input) => ({
        variantId: input.dataset.variantId,
        price: Number(input.dataset.price) || 0,
        title: input.dataset.title || "Add-on",
        size: input.dataset.size || "",
        image: input.dataset.image || "",
        categoryTitle: input.dataset.categoryTitle || null,
        source: input.dataset.upsellSource || "",
        input: input,
      }));
  }

  function formatMoney(cents) {
    return `£${(cents / 100).toFixed(2)}`;
  }

  function getSelectedVariantTitle() {
    const selectedRadio = document.querySelector(
      'input[name*="Size"]:checked, input[name*="options"]:checked'
    );
    if (selectedRadio) {
      return selectedRadio.value.split("/")[0].trim();
    }

    const selectedDropdown = document.querySelector(
      'select[name*="Size"], select[name*="options"]'
    );
    if (selectedDropdown && selectedDropdown.value) {
      return selectedDropdown.value.split("/")[0].trim();
    }

    return null;
  }

  function hasAnyAddonSelected() {
    let hasSelection = false;
    addonGroupsNew.forEach((groupData) => {
      if (groupData.type === "drawer") {
        // Check if any category has a selection
        Object.values(groupData.categorySelections || {}).forEach(
          (selection) => {
            if (selection.variantId) hasSelection = true;
          }
        );
      } else if (groupData.type === "simple") {
        if (
          groupData.selectedVariants &&
          groupData.selectedVariants.length > 0
        ) {
          hasSelection = true;
        }
      }
    });
    return hasSelection;
  }

  function updateExpressPaymentButtonVisibility() {
    const expressPaymentBtn = document.querySelector(
      'div[data-shopify="payment-button"]'
    );
    if (!expressPaymentBtn) return;

    if (hasAnyAddonSelected()) {
      expressPaymentBtn.style.display = "none";
    } else {
      expressPaymentBtn.style.display = "block";
    }
  }

  // ============================================================================
  // INITIALIZATION - GROUPS
  // ============================================================================

  function initializeAddonGroups() {
    // Initialize drawer groups
    drawerTriggers.forEach((trigger) => {
      const groupIndex = trigger.dataset.groupIndex;
      const groupTitle = trigger.dataset.groupTitle;
      const groupSubtitle = trigger.dataset.groupSubtitle;
      const overlay = trigger.nextElementSibling;
      const container = trigger.closest(".drawer-group-container-new");

      // Count total categories
      const totalCategories =
        overlay?.querySelectorAll(".category-tab-panel").length || 0;

      addonGroupsNew.set(groupIndex, {
        type: "drawer",
        title: groupTitle,
        subtitle: groupSubtitle,
        trigger: trigger,
        overlay: overlay,
        drawerContent: overlay?.querySelector(".drawer-content-new"),
        container: container,
        selectedDisplay: container?.querySelector(
          ".selected-addons-display-new"
        ),
        totalCategories: totalCategories,
        categorySelections: {}, // { categoryIndex: { variantId, price, title, categoryTitle } }
      });
    });

    // Initialize simple groups
    simpleGroups.forEach((group) => {
      const groupIndex = group.dataset.groupIndex;
      const groupTitle = group.dataset.groupTitle;
      const groupSubtitle = group.dataset.groupSubtitle;
      const isMultiSelect = group.dataset.isMultiSelect === "true";

      addonGroupsNew.set(groupIndex, {
        type: "simple",
        title: groupTitle,
        subtitle: groupSubtitle,
        isMultiSelect: isMultiSelect,
        container: group,
        selectedVariants: [], // Array of { variantId, price, title }
      });
    });
  }

  // ============================================================================
  // TAB SWITCHING
  // ============================================================================

  function setupTabSwitching() {
    const tabButtons = document.querySelectorAll(".category-tab-btn");

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const groupIndex = this.dataset.groupIndex;
        const categoryIndex = this.dataset.categoryIndex;

        // Update active tab button
        const parentTabs = this.closest(".category-tabs-new");
        parentTabs
          .querySelectorAll(".category-tab-btn")
          .forEach((b) => b.classList.remove("active"));
        this.classList.add("active");

        // Update active tab panel
        const tabContent = this.closest(".drawer-content-new").querySelector(
          ".category-tabs-content-new"
        );
        tabContent
          .querySelectorAll(".category-tab-panel")
          .forEach((panel) => panel.classList.remove("active"));
        const activePanel = tabContent.querySelector(
          `.category-tab-panel[data-category-index="${categoryIndex}"]`
        );
        if (activePanel) {
          activePanel.classList.add("active");

          // Inline: clicking a tab whose category is already selected reveals its
          // options again (re-pick). Tabs stay visible (unlike the focused Change
          // flow), so clear `inline-changing` and other panels' changing state.
          const groupData = addonGroupsNew.get(groupIndex);
          if (isInlineAddonMode(activePanel) && groupData) {
            tabContent
              .querySelectorAll(".category-tab-panel.category-is-changing")
              .forEach((p) => p.classList.remove("category-is-changing"));
            groupData.container?.classList.remove("inline-changing");

            const sel = groupData.categorySelections[categoryIndex];
            if (sel && sel.variantId) {
              activePanel.classList.add("category-is-changing");
            }
            syncInlineCategoryVisibility(groupIndex);
          }

          // Update addons for this category
          updateCategoryAddons(groupIndex, categoryIndex);
        }
      });
    });
  }

  // ============================================================================
  // VARIANT FILTERING FOR CATEGORIES
  // ============================================================================

  // Move badged cards (.has-upsell-badge) to the top of the list, carrying each
  // card's adjacent more-info popup sibling with it so `card.nextElementSibling`
  // stays correct. Runs once per list (guarded); with no badges it's a no-op.
  function reorderBadgedAddonsFirst(list) {
    if (list.dataset.showmoreOrdered === "true") return;
    list.dataset.showmoreOrdered = "true";

    const cards = Array.from(list.querySelectorAll(":scope > .addon-card-new"));
    const badged = cards.filter((c) => c.classList.contains("has-upsell-badge"));
    if (badged.length === 0 || badged.length === cards.length) return;

    // Prepend in reverse so the first badged card ends up on top, preserving
    // the relative order of both badged and non-badged groups.
    badged.reverse().forEach((card) => {
      const popup =
        card.nextElementSibling &&
        card.nextElementSibling.classList.contains("more-info-new")
          ? card.nextElementSibling
          : null;
      // Insert the popup first, then the card before it, keeping card→popup order.
      if (popup) list.insertBefore(popup, list.firstElementChild);
      list.insertBefore(card, list.firstElementChild);
    });
  }

  // After the variant filter has set each card's display, collapse all but the
  // first *visible* card behind a "Show More Options (N)" toggle. Only applies
  // when 2+ cards are visible. Re-run safe — reflects the current visible set.
  // Show-more/badged-first applies ONLY when the group renders inline (the
  // "checkboxes" toggle is on -> .inline-mode) AND the viewport is small enough
  // for inline layout (<=991px). In the drawer, all options stay visible.
  function isInlineAddonMode(panel) {
    const container = panel.closest(".drawer-group-container-new");
    return (
      !!container &&
      container.classList.contains("inline-mode") &&
      window.matchMedia("(max-width: 991px)").matches
    );
  }

  // In inline mode, once a category has a selection we collapse its options list
  // (the shopper sees the selected card + "Change" instead). Clicking "Change"
  // sets `category-is-changing` to reveal the options again. This function is
  // purely reflective: it mirrors the current selection state onto each panel's
  // `category-has-selection` class and the container's `inline-all-selected`
  // class. It does NOT touch `category-is-changing` — that is owned by the
  // selection/clear/change handlers, so callers must set it before calling.
  function syncInlineCategoryVisibility(groupIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "drawer" || !groupData.overlay) return;

    const panels = groupData.overlay.querySelectorAll(".category-tab-panel");
    let allSelected = panels.length > 0;
    let anyChanging = false;

    panels.forEach((panel) => {
      const categoryIndex = panel.dataset.categoryIndex;
      const selection = groupData.categorySelections[categoryIndex];
      const hasSelection = !!(selection && selection.variantId);

      panel.classList.toggle("category-has-selection", hasSelection);

      if (!hasSelection) allSelected = false;
      if (panel.classList.contains("category-is-changing")) anyChanging = true;
    });

    const container = groupData.container;
    if (container) {
      // Hide the whole inline card shell only when nothing is left to pick.
      container.classList.toggle(
        "inline-all-selected",
        allSelected && !anyChanging
      );
    }
  }

  // Cancel an in-progress inline "Change": drop the changing flag(s) for this
  // group so the category collapses back to its selected card. Returns true if
  // it actually cancelled a change (so the close button can decide what to do).
  function cancelInlineChange(overlay) {
    if (!overlay) return false;
    const changingPanels = overlay.querySelectorAll(
      ".category-tab-panel.category-is-changing"
    );
    if (changingPanels.length === 0) return false;

    changingPanels.forEach((panel) =>
      panel.classList.remove("category-is-changing")
    );

    const container = overlay.closest(".drawer-group-container-new");
    container?.classList.remove("inline-changing");

    const tabsContent = overlay.querySelector(".category-tabs-content-new");
    const groupIndex = tabsContent?.dataset.groupIndex;
    if (groupIndex != null) syncInlineCategoryVisibility(groupIndex);
    return true;
  }

  function applyAddonShowMore(panel) {
    const list = panel.querySelector(".product-addons-new");
    if (!list) return;

    let button = list.querySelector(":scope > .addon-show-more-new");

    // In drawer mode (or above 991px), never collapse — clear any state that a
    // previous inline pass may have left, then bail so all options show.
    if (!isInlineAddonMode(panel)) {
      list
        .querySelectorAll(".addon-hidden-by-showmore")
        .forEach((c) => c.classList.remove("addon-hidden-by-showmore"));
      list.classList.remove("addon-is-collapsed");
      if (button) button.remove();
      return;
    }

    reorderBadgedAddonsFirst(list);

    // Visible = not hidden by the variant filter's inline display:none.
    const visibleCards = Array.from(
      list.querySelectorAll(":scope > .addon-card-new")
    ).filter((c) => c.style.display !== "none");

    // Clear any previous show-more hiding before recomputing.
    list
      .querySelectorAll(".addon-hidden-by-showmore")
      .forEach((c) => c.classList.remove("addon-hidden-by-showmore"));

    if (visibleCards.length <= 1) {
      list.classList.remove("addon-is-collapsed");
      if (button) button.remove();
      return;
    }

    // Preserve expanded/collapsed state across re-runs; default to collapsed.
    const isCollapsed = !list.classList.contains("addon-is-expanded");
    if (isCollapsed) {
      list.classList.add("addon-is-collapsed");
      visibleCards.slice(1).forEach((c) => {
        c.classList.add("addon-hidden-by-showmore");
      });
    } else {
      list.classList.remove("addon-is-collapsed");
    }

    const hiddenCount = visibleCards.length - 1;
    const label = isCollapsed
      ? `Show More Options (${hiddenCount})`
      : "Show Less Options";

    if (!button) {
      button = document.createElement("button");
      button.type = "button";
      button.className = "addon-show-more-new";
      list.appendChild(button);
    } else {
      // Keep the button last so it sits below the (possibly reordered) cards.
      list.appendChild(button);
    }
    button.innerHTML =
      `<span class="addon-show-more-text-new">${label}</span>` +
      `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">` +
      `<path d="M11.8199 1.12875L6.8786 7.32C6.40985 7.88625 5.68735 7.88625 5.23798 7.32L0.296728 1.12875C-0.172022 0.5425 0.0623532 0.09375 0.784853 0.09375H11.3317C12.0742 0.09375 12.2886 0.543125 11.8199 1.12875Z" fill="#5a7670"/>` +
      `</svg>`;
  }

  function updateCategoryAddons(groupIndex, categoryIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "drawer") return;

    const selectedVariantTitle = getSelectedVariantTitle();
    const panel = groupData.overlay.querySelector(
      `.category-tab-panel[data-category-index="${categoryIndex}"]`
    );
    if (!panel) return;

    const variantFilter = panel.dataset.variantFilter === "true";
    const filterNames = panel.dataset.filterNames
      ? panel.dataset.filterNames.split(",").map((n) => n.trim())
      : [];

    const addonCards = panel.querySelectorAll(".addon-card-new");

    addonCards.forEach((card) => {
      const variants = card.dataset.addonVariants
        .split(",")
        .map((v) => v.trim());
      const variantIds = card.dataset.variantIds.split(",");
      const variantPrices = card.dataset.variantPrices.split(",").map(Number);
      const variantComparePrices = card.dataset.variantComparePrices
        .split(",")
        .map(Number);
      const variantAvailable = card.dataset.variantAvailable
        ? card.dataset.variantAvailable
            .split(",")
            .map((v) => v.trim() === "true")
        : [];

      let matchedIndex = -1;
      let shouldShowCard = false;

      if (variantFilter) {
        // Match based on main product variant
        if (selectedVariantTitle) {
          matchedIndex = variants.findIndex((v, index) => {
            const variantName = v.split("/")[0].trim();
            const isAvailable = variantAvailable[index] !== false;
            return variantName === selectedVariantTitle && isAvailable;
          });
          shouldShowCard = matchedIndex !== -1;
        }
      } else {
        // Match based on filter names or show first available
        if (filterNames.length > 0) {
          matchedIndex = variants.findIndex((v, index) => {
            const addonVariantName = v.split("/")[0].trim();
            const isAvailable = variantAvailable[index] !== false;
            return filterNames.includes(addonVariantName) && isAvailable;
          });
          shouldShowCard = matchedIndex !== -1;
        } else {
          // No filter, show first available
          matchedIndex = variants.findIndex(
            (v, index) => variantAvailable[index] !== false
          );
          shouldShowCard = matchedIndex !== -1;
        }
      }

      if (shouldShowCard && matchedIndex !== -1) {
        card.style.display = "block";

        // Update radio input
        const radioInput = card.querySelector('input[type="radio"]');
        if (radioInput) {
          // Uncheck the radio first to reset its state when value changes
          radioInput.checked = false;
          radioInput.value = variantIds[matchedIndex];
          radioInput.dataset.price = variantPrices[matchedIndex];
        }

        // Update prices
        const priceElement = card.querySelector(".addon-price-new");
        if (priceElement)
          priceElement.textContent = formatMoney(variantPrices[matchedIndex]);

        const comparePriceElement = card.querySelector(".old-price-new");
        if (comparePriceElement) {
          const comparePrice = variantComparePrices[matchedIndex];
          if (comparePrice && comparePrice > 0) {
            comparePriceElement.textContent = formatMoney(comparePrice);
            comparePriceElement.style.display = "";
          } else {
            comparePriceElement.style.display = "none";
          }
        }

        // Update savings
        const savingsElement = card.querySelector(".you-save-new");
        const savingsAmountElement = card.querySelector(".saving-amnt");
        if (savingsElement && savingsAmountElement) {
          const comparePrice = variantComparePrices[matchedIndex];
          const currentPrice = variantPrices[matchedIndex];
          if (comparePrice && comparePrice > 0 && comparePrice > currentPrice) {
            savingsElement.style.display = "block";
            savingsAmountElement.textContent = formatMoney(
              comparePrice - currentPrice
            );
          } else {
            savingsElement.style.display = "none";
          }
        }

        // Update more info popup prices
        const moreInfoPopup = card.nextElementSibling;
        if (
          moreInfoPopup &&
          moreInfoPopup.classList.contains("more-info-new")
        ) {
          const popupPrice = moreInfoPopup.querySelector(
            ".more-info-price-new"
          );
          const popupOldPrice = moreInfoPopup.querySelector(
            ".more-info-old-price-new"
          );
          if (popupPrice)
            popupPrice.textContent = formatMoney(variantPrices[matchedIndex]);
          if (popupOldPrice) {
            const comparePrice = variantComparePrices[matchedIndex];
            if (comparePrice && comparePrice > 0) {
              popupOldPrice.textContent = formatMoney(comparePrice);
              popupOldPrice.style.display = "";
            } else {
              popupOldPrice.style.display = "none";
            }
          }

          // Update more info popup savings
          const popupSavingsElement = moreInfoPopup.querySelector(".you-save-new");
          const popupSavingsAmountElement = moreInfoPopup.querySelector(".saving-amnt");
          if (popupSavingsElement && popupSavingsAmountElement) {
            const comparePrice = variantComparePrices[matchedIndex];
            const currentPrice = variantPrices[matchedIndex];
            if (comparePrice && comparePrice > 0 && comparePrice > currentPrice) {
              popupSavingsElement.style.display = "block";
              popupSavingsAmountElement.textContent = formatMoney(
                comparePrice - currentPrice
              );
            } else {
              popupSavingsElement.style.display = "none";
            }
          }
        }
      } else {
        card.style.display = "none";
      }
    });

    // Restore selection if exists
    const categorySelection = groupData.categorySelections[categoryIndex];
    if (categorySelection && categorySelection.variantId) {
      const targetInput = panel.querySelector(
        `input[value="${categorySelection.variantId}"]`
      );
      if (
        targetInput &&
        targetInput.closest(".addon-card-new").style.display !== "none"
      ) {
        targetInput.checked = true;
        targetInput.closest(".addon-card-new").classList.add("selected");
      }
    }

    // Collapse extra (visible) options behind a "Show More Options" toggle,
    // after the variant filter above has decided which cards are visible.
    applyAddonShowMore(panel);
  }

  function updateAllCategoriesForGroup(groupIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "drawer") return;

    const panels = groupData.overlay.querySelectorAll(".category-tab-panel");
    panels.forEach((panel) => {
      const categoryIndex = panel.dataset.categoryIndex;
      updateCategoryAddons(groupIndex, categoryIndex);
    });
  }

  // ============================================================================
  // SIMPLE MODE VARIANT FILTERING
  // ============================================================================

  function updateSimpleGroupAddons(groupIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "simple") return;

    const selectedVariantTitle = getSelectedVariantTitle();
    const addonOptions = groupData.container.querySelectorAll(
      ".simple-addon-option-new"
    );

    addonOptions.forEach((option) => {
      const variants = option.dataset.addonVariants
        ? option.dataset.addonVariants.split(",").map((v) => v.trim())
        : [];
      const variantIds = option.dataset.variantIds.split(",");
      const variantPrices = option.dataset.variantPrices.split(",").map(Number);
      const variantComparePrices = option.dataset.variantComparePrices
        .split(",")
        .map(Number);
      const variantAvailable = option.dataset.variantAvailable
        ? option.dataset.variantAvailable
            .split(",")
            .map((v) => v.trim() === "true")
        : [];

      // For simple mode, always match with main variant or show first available
      let matchedIndex = -1;

      if (selectedVariantTitle && variants.length > 0) {
        matchedIndex = variants.findIndex((v, index) => {
          const variantName = v.split("/")[0].trim();
          const isAvailable = variantAvailable[index] !== false;
          return variantName === selectedVariantTitle && isAvailable;
        });
      }

      if (matchedIndex === -1) {
        matchedIndex = variantAvailable.findIndex((avail) => avail !== false);
      }

      if (matchedIndex !== -1) {
        option.style.display = "flex";

        const input = option.querySelector("input");
        if (input) {
          input.dataset.variantId = variantIds[matchedIndex];
          input.dataset.price = variantPrices[matchedIndex];
        }

        const currentPrice = variantPrices[matchedIndex];
        const priceElement = option.querySelector(".simple-addon-price-new");
        const comparePriceElement = option.querySelector(
          ".simple-old-price-new"
        );
        const priceContainer = option.querySelector(".item-price");
        const titleElement = option.querySelector(".simple-addon-title-new");

        // Check if product is free
        if (currentPrice === 0) {
          // Show price section with £0.00
          if (priceContainer) {
            priceContainer.style.display = "";
          }
          // Add "Free: " prefix to title
          if (titleElement && !titleElement.textContent.startsWith("FREE: ")) {
            titleElement.setAttribute(
              "data-original-title",
              titleElement.textContent
            );
            titleElement.textContent = "FREE: " + titleElement.textContent;
          }
          // Show £0.00 price
          if (priceElement) {
            priceElement.textContent = formatMoney(0);
          }
          // Show compare price for free items if exists
          if (comparePriceElement) {
            const comparePrice = variantComparePrices[matchedIndex];
            if (comparePrice && comparePrice > 0) {
              comparePriceElement.textContent = formatMoney(comparePrice);
              comparePriceElement.style.display = "";
            } else {
              comparePriceElement.style.display = "none";
            }
          }
        } else {
          // Show price section
          if (priceContainer) {
            priceContainer.style.display = "";
          }
          // Remove "Free: " prefix if it exists
          if (
            titleElement &&
            titleElement.hasAttribute("data-original-title")
          ) {
            titleElement.textContent = titleElement.getAttribute(
              "data-original-title"
            );
            titleElement.removeAttribute("data-original-title");
          }
          // Update price display
          if (priceElement) {
            priceElement.textContent = formatMoney(currentPrice);
          }
          // Update compare price
          if (comparePriceElement) {
            const comparePrice = variantComparePrices[matchedIndex];
            if (comparePrice && comparePrice > 0) {
              comparePriceElement.textContent = formatMoney(comparePrice);
              comparePriceElement.style.display = "";
            } else {
              comparePriceElement.style.display = "none";
            }
          }
        }
      } else {
        option.style.display = "none";
      }
    });
  }

  // ============================================================================
  // SELECTION HANDLERS - DRAWER MODE
  // ============================================================================

  function handleDrawerAddonSelection(radioInput) {
    const groupIndex = radioInput.dataset.groupIndex;
    const categoryIndex = radioInput.dataset.categoryIndex;
    const categoryTitle = radioInput.dataset.categoryTitle;
    const groupData = addonGroupsNew.get(groupIndex);

    if (!groupData || groupData.type !== "drawer") return;

    const panel = radioInput.closest(".category-tab-panel");
    const addonCards = panel.querySelectorAll(".addon-card-new");
    addonCards.forEach((card) => card.classList.remove("selected"));

    if (radioInput.checked) {
      const variantId = radioInput.value;
      const price = parseInt(radioInput.dataset.price);
      const addonCard = radioInput.closest(".addon-card-new");
      const title =
        addonCard.querySelector(".addon-title-new")?.textContent || "";

      addonCard.classList.add("selected");

      // Store selection for this category
      groupData.categorySelections[categoryIndex] = {
        variantId: variantId,
        price: price,
        title: title,
        categoryIndex: categoryIndex,
        categoryTitle: categoryTitle,
      };

      // Update trigger button to show selection count
      updateDrawerTriggerButton(groupIndex);

      // Inline: making a selection finishes any "change" and collapses this
      // category's options again (and exits the focused-change tab state).
      if (panel) panel.classList.remove("category-is-changing");
      groupData.container?.classList.remove("inline-changing");
      syncInlineCategoryVisibility(groupIndex);

      // Check if all categories are selected
      const selectionCount = Object.keys(groupData.categorySelections).filter(
        (key) => groupData.categorySelections[key].variantId
      ).length;
      const allCategoriesSelected =
        selectionCount === groupData.totalCategories;

      if (allCategoriesSelected) {
        // Close drawer if all categories are selected (no-op inline).
        closeDrawer(groupData.overlay);
      } else {
        // Auto-advance to the next unselected category's tab so its options are
        // shown (drawer and inline both benefit — the shopper keeps picking).
        const allTabs = groupData.overlay.querySelectorAll(".category-tab-btn");
        let nextUnselectedTab = null;

        // Find the first unselected tab
        allTabs.forEach((tab) => {
          const tabCategoryIndex = tab.dataset.categoryIndex;
          if (
            !groupData.categorySelections[tabCategoryIndex] &&
            !nextUnselectedTab
          ) {
            nextUnselectedTab = tab;
          }
        });

        if (nextUnselectedTab) {
          // Switch to the unselected tab
          const parentTabs = nextUnselectedTab.closest(".category-tabs-new");
          parentTabs
            .querySelectorAll(".category-tab-btn")
            .forEach((btn) => btn.classList.remove("active"));
          nextUnselectedTab.classList.add("active");

          // Update active tab panel
          const tabContent = nextUnselectedTab
            .closest(".drawer-content-new")
            .querySelector(".category-tabs-content-new");
          tabContent
            .querySelectorAll(".category-tab-panel")
            .forEach((panel) => panel.classList.remove("active"));
          const activePanel = tabContent.querySelector(
            `.category-tab-panel[data-category-index="${nextUnselectedTab.dataset.categoryIndex}"]`
          );
          if (activePanel) {
            activePanel.classList.add("active");
            // Populate the newly-shown category's options (needed inline, where
            // nothing else triggers a recompute for this panel).
            updateCategoryAddons(
              groupIndex,
              nextUnselectedTab.dataset.categoryIndex
            );
          }
        }
      }
    }

    updateExpressPaymentButtonVisibility();
  }

  function updateDrawerTriggerButton(groupIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "drawer") return;

    const trigger = groupData.trigger;
    const selectedDisplay = groupData.selectedDisplay;
    const selectionCount = Object.keys(groupData.categorySelections).filter(
      (key) => groupData.categorySelections[key].variantId
    ).length;

    // Update selected products display
    if (selectedDisplay && selectionCount > 0) {
      let displayHTML = '<div class="selected-products-list-new">';

      Object.entries(groupData.categorySelections).forEach(
        ([categoryIndex, selection]) => {
          if (selection.variantId) {
            // Find the addon card to get image and details
            const panel = groupData.overlay.querySelector(
              `.category-tab-panel[data-category-index="${categoryIndex}"]`
            );
            const addonCard = panel
              ?.querySelector(`input[value="${selection.variantId}"]`)
              ?.closest(".addon-card-new");
            const image =
              addonCard?.querySelector(".addon-image-new img")?.src || "";
            const price =
              addonCard?.querySelector(".addon-price-new")?.textContent || "";
            const comparePriceElement =
              addonCard?.querySelector(".old-price-new");
            const comparePrice =
              comparePriceElement &&
              comparePriceElement.style.display !== "none"
                ? comparePriceElement.textContent
                : "";
            const showRrp = addonCard?.dataset.showRrp === "true";

            let priceHTML = "";
            if (comparePrice) {
              const rrpPrefix = showRrp ? '<span class="selected-rrp-prefix">RRP:&nbsp;</span>' : '';
              priceHTML = `
                <p class="selected-product-price-new">
                  <span class="selected-old-price-new">${rrpPrefix}${comparePrice}</span>
                  <span class="selected-new-price-new">${price}</span>
                </p>
              `;
            } else {
              priceHTML = `<p class="selected-product-price-new">${price}</p>`;
            }

            displayHTML += `
            <div class="selected-product-card-new" data-category-index="${categoryIndex}">
              <div class="selected-product-image-new">
                <img src="${image}" alt="${selection.title}" />
              </div>
              <div class="selected-product-info-new">
                <p class="selected-category-title-new">${selection.categoryTitle}</p>
                <h4 class="selected-product-title-new">${selection.title}</h4>
                ${priceHTML}
              </div>
              <div class="selected-product-actions-new">
                <button
                  class="change-selected-product-new"
                  data-group-index="${groupIndex}"
                  data-category-index="${categoryIndex}"
                  type="button"
                >
                  Change
                </button>
                <button
                  class="remove-selected-product-new"
                  data-group-index="${groupIndex}"
                  data-category-index="${categoryIndex}"
                  type="button"
                >
                  <i class="feather-x"></i>
                </button>
              </div>
            </div>
          `;
          }
        }
      );

      displayHTML += "</div>";
      selectedDisplay.innerHTML = displayHTML;
      selectedDisplay.style.display = "block";
    } else if (selectedDisplay) {
      selectedDisplay.innerHTML = "";
      selectedDisplay.style.display = "none";
    }

    // Show/hide trigger button based on whether all categories are selected
    const allCategoriesSelected =
      selectionCount === groupData.totalCategories &&
      groupData.totalCategories > 0;

    if (allCategoriesSelected) {
      trigger.style.display = "none";
    } else {
      trigger.style.display = "";

      // Get all category titles from tabs
      const allCategories = [];
      const tabPanels = groupData.overlay.querySelectorAll(
        ".category-tab-panel"
      );
      tabPanels.forEach((panel) => {
        allCategories.push({
          index: panel.dataset.categoryIndex,
          title: panel.dataset.categoryTitle,
        });
      });

      // Find remaining (unselected) categories
      const remainingCategories = allCategories.filter(
        (cat) => !groupData.categorySelections[cat.index]
      );

      // Update trigger button text
      const upsellDiv = trigger.querySelector(".product-upsell-new");
      if (upsellDiv) {
        // If no selections at all, show default title
        if (selectionCount === 0) {
          upsellDiv.innerHTML = `
            <p class="upsell-title">${groupData.title}</p>
            <p class="upsell-desc">${groupData.subtitle || ""}</p>
          `;
        } else if (remainingCategories.length > 0) {
          // If some selections exist, show remaining categories
          const remainingNames = remainingCategories
            .map((cat) => cat.title)
            .join(", ");
          upsellDiv.innerHTML = `
            <p class="upsell-title">Add ${remainingNames}</p>
            <p class="upsell-desc">${groupData.subtitle}</p>
          `;
        } else {
          // Fallback to default title
          upsellDiv.innerHTML = `
            <p class="upsell-title">${groupData.title}</p>
            <p class="upsell-desc">${groupData.subtitle || ""}</p>
          `;
        }
      }
    }
  }

  function clearCategorySelection(groupIndex, categoryIndex) {
    const groupData = addonGroupsNew.get(groupIndex);
    if (!groupData || groupData.type !== "drawer") return;

    const panel = groupData.overlay.querySelector(
      `.category-tab-panel[data-category-index="${categoryIndex}"]`
    );
    if (panel) {
      const checkedInput = panel.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        checkedInput.checked = false;
        const addonCard = checkedInput.closest(".addon-card-new");
        if (addonCard) addonCard.classList.remove("selected");
      }
    }

    delete groupData.categorySelections[categoryIndex];
    updateDrawerTriggerButton(groupIndex);
    // Inline: no selection -> options list shows again for this category.
    if (panel) panel.classList.remove("category-is-changing");
    groupData.container?.classList.remove("inline-changing");

    // Inline: after removing, make the just-emptied category the active tab so
    // ITS options are the ones shown (not the other still-selected category).
    if (panel && isInlineAddonMode(panel)) {
      groupData.overlay
        .querySelectorAll(".category-tab-btn")
        .forEach((btn) =>
          btn.classList.toggle(
            "active",
            btn.dataset.categoryIndex === categoryIndex
          )
        );
      groupData.overlay
        .querySelectorAll(".category-tab-panel")
        .forEach((p) =>
          p.classList.toggle(
            "active",
            p.dataset.categoryIndex === categoryIndex
          )
        );
      updateCategoryAddons(groupIndex, categoryIndex);
    }

    syncInlineCategoryVisibility(groupIndex);
    updateExpressPaymentButtonVisibility();
  }

  // ============================================================================
  // SELECTION HANDLERS - SIMPLE MODE
  // ============================================================================

  function handleSimpleAddonSelection(input) {
    const groupIndex = input.dataset.groupIndex;
    const groupData = addonGroupsNew.get(groupIndex);

    if (!groupData || groupData.type !== "simple") return;

    const variantId = input.dataset.variantId;
    const price = parseInt(input.dataset.price);
    const option = input.closest(".simple-addon-option-new");
    const title =
      option.querySelector(".simple-addon-title-new")?.textContent || "";
    const removeBtn = option.querySelector(".simple-remove-btn-new");

    if (groupData.isMultiSelect) {
      // Checkbox - multi-select
      if (input.checked) {
        groupData.selectedVariants.push({ variantId, price, title });
        if (removeBtn) removeBtn.style.display = "flex";
      } else {
        groupData.selectedVariants = groupData.selectedVariants.filter(
          (v) => v.variantId !== variantId
        );
        if (removeBtn) removeBtn.style.display = "none";
      }
    } else {
      // Checkbox with single-select behavior
      const allOptions = groupData.container.querySelectorAll(
        ".simple-addon-option-new"
      );

      // Uncheck all other checkboxes and hide their remove buttons
      allOptions.forEach((opt) => {
        if (opt !== option) {
          const otherInput = opt.querySelector("input[type='checkbox']");
          if (otherInput) {
            otherInput.checked = false;
          }
          const btn = opt.querySelector(".simple-remove-btn-new");
          if (btn) btn.style.display = "none";
        }
      });

      if (input.checked) {
        groupData.selectedVariants = [{ variantId, price, title }];
        if (removeBtn) removeBtn.style.display = "flex";
      } else {
        groupData.selectedVariants = [];
        if (removeBtn) removeBtn.style.display = "none";
      }
    }

    updateExpressPaymentButtonVisibility();
  }

  function handleSimpleRemove(removeBtn) {
    const option = removeBtn.closest(".simple-addon-option-new");
    const input = option.querySelector("input");

    if (input) {
      input.checked = false;
      removeBtn.style.display = "none";
      handleSimpleAddonSelection(input);
    }
  }

  // ============================================================================
  // DRAWER OPEN/CLOSE
  // ============================================================================

  function openDrawer(overlay) {
    allDrawerOverlays.forEach((o) => closeDrawer(o));

    overlay.classList.add("active");
    const drawerContent = overlay.querySelector(".drawer-content-new");
    if (drawerContent) drawerContent.classList.add("active");

    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "15px";

    // Get group index and update first visible tab
    const tabsContent = overlay.querySelector(".category-tabs-content-new");
    if (tabsContent) {
      const groupIndex = tabsContent.dataset.groupIndex;
      const firstVisiblePanel = overlay.querySelector(
        ".category-tab-panel.active"
      );
      if (firstVisiblePanel) {
        const categoryIndex = firstVisiblePanel.dataset.categoryIndex;
        updateCategoryAddons(groupIndex, categoryIndex);
      }
    }
  }

  function closeDrawer(overlay) {
    overlay.classList.remove("active");
    const drawerContent = overlay.querySelector(".drawer-content-new");
    if (drawerContent) drawerContent.classList.remove("active");

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  // ============================================================================
  // MORE INFO POPUP
  // ============================================================================

  function setupMoreInfoButtons() {
    const moreInfoButtons = document.querySelectorAll(".more-info-trigger-new");

    moreInfoButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const addonCard = this.closest(".addon-card-new");
        const moreInfoPopup = addonCard.nextElementSibling;

        if (
          moreInfoPopup &&
          moreInfoPopup.classList.contains("more-info-new")
        ) {
          moreInfoPopup.classList.add("active");
          document.body.style.overflow = "hidden";

          // Initialize Swiper for more-info image carousel if exists
          const swiperContainer = moreInfoPopup.querySelector(".more-info-swiper");
          if (swiperContainer && !swiperContainer.swiper) {
            const moreInfoImage = moreInfoPopup.querySelector(".more-info-image");
            const prevBtn = moreInfoImage.querySelector(".more-info-prev");
            const nextBtn = moreInfoImage.querySelector(".more-info-next");

            const swiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              pagination: {
                el: swiperContainer.querySelector(".more-info-pagination"),
                clickable: true,
              },
              navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
              },
            });
          }
        }
      });
    });
  }

  function setupMoreInfoCloseButtons() {
    const popups = document.querySelectorAll(".more-info-new.pop-up");

    popups.forEach((popup) => {
      const closeBtn = popup.querySelector(".more-info-close-new");
      if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          closePopup(popup);
        });
      }

      popup.addEventListener("click", (e) => {
        const child = popup.querySelector(".more-info-child");
        if (child && !child.contains(e.target)) {
          closePopup(popup);
        }
      });
    });

    function closePopup(popup) {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }
  }

  // ============================================================================
  // CLEAR SELECTION BUTTONS
  // ============================================================================

  function setupClearButtons() {
    document.addEventListener("click", function (e) {
      if (e.target.closest(".clear-selection-new")) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.closest(".clear-selection-new");
        const addonCard = button.closest(".addon-card-new");
        const radioInput = addonCard.querySelector('input[type="radio"]');

        if (radioInput) {
          const groupIndex = radioInput.dataset.groupIndex;
          const categoryIndex = radioInput.dataset.categoryIndex;
          clearCategorySelection(groupIndex, categoryIndex);
        }
      }

      // Remove selected product from display area
      if (e.target.closest(".remove-selected-product-new")) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.closest(".remove-selected-product-new");
        const groupIndex = button.dataset.groupIndex;
        const categoryIndex = button.dataset.categoryIndex;
        clearCategorySelection(groupIndex, categoryIndex);
      }

      // Change selected product - open drawer and activate category tab
      if (e.target.closest(".change-selected-product-new")) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.closest(".change-selected-product-new");
        const groupIndex = button.dataset.groupIndex;
        const categoryIndex = button.dataset.categoryIndex;
        const groupData = addonGroupsNew.get(groupIndex);

        if (!groupData || groupData.type !== "drawer") return;

        const changePanel = groupData.overlay?.querySelector(
          `.category-tab-panel[data-category-index="${categoryIndex}"]`
        );

        // Inline mode: no drawer to open — reveal ONLY this category's options
        // in place (activate its tab/panel), so the shopper can pick a different
        // one without touching other categories.
        if (changePanel && isInlineAddonMode(changePanel)) {
          changePanel.classList.add("category-is-changing");

          // Activate this category's tab + panel so only its options show.
          groupData.overlay
            .querySelectorAll(".category-tab-btn")
            .forEach((btn) => {
              btn.classList.toggle(
                "active",
                btn.dataset.categoryIndex === categoryIndex
              );
            });
          groupData.overlay
            .querySelectorAll(".category-tab-panel")
            .forEach((panel) => {
              panel.classList.toggle(
                "active",
                panel.dataset.categoryIndex === categoryIndex
              );
            });

          // Change (from the selected card) focuses this one category: hide the
          // other tabs and show the ✕. (Tab-click re-pick does NOT do this.)
          groupData.container?.classList.add("inline-changing");

          // Clears `inline-all-selected` so the (now revealed) shell shows.
          syncInlineCategoryVisibility(groupIndex);
          updateCategoryAddons(groupIndex, categoryIndex);
          changePanel.scrollIntoView({ behavior: "smooth", block: "nearest" });
          return;
        }

        {
          // Open the drawer
          openDrawer(groupData.overlay);

          // Activate the specific category tab
          const tabButtons =
            groupData.overlay.querySelectorAll(".category-tab-btn");
          tabButtons.forEach((btn) => {
            if (btn.dataset.categoryIndex === categoryIndex) {
              btn.classList.add("active");
            } else {
              btn.classList.remove("active");
            }
          });

          // Activate the specific category panel
          const tabPanels = groupData.overlay.querySelectorAll(
            ".category-tab-panel"
          );
          tabPanels.forEach((panel) => {
            if (panel.dataset.categoryIndex === categoryIndex) {
              panel.classList.add("active");
              updateCategoryAddons(groupIndex, categoryIndex);
            } else {
              panel.classList.remove("active");
            }
          });
        }
      }
    });
  }

  // ============================================================================
  // ADD TO CART
  // ============================================================================

  async function handleCombinedAddToCart(e) {
    if (e) e.preventDefault();

    const mainVariantId = document.querySelector('input[name="id"]')?.value;
    if (!mainVariantId) return;

    // Main product variant this upsell was attached to (for order tracking).
    const mainVariantTitle = getSelectedVariantTitle() || "";

    // A/B rollout tracking (CONTROL branch): this branch shows the drawer upsell
    // on ALL devices, so the source is purely the device/viewport at add time
    // (mobile <=991px vs desktop). Underscore-prefixed values as requested.
    const upsellSource = window.matchMedia("(max-width: 991px)").matches
      ? "_control_upsell_mobile"
      : "_control_upsell_desktop";

    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

    // Get delivery date properties (Flare integration)
    const formattedDeliveryDateInput = document.querySelector(
      'input[name="properties[Delivery Date]"]'
    );
    const flareDeliveryInput = document.querySelector(
      'input[name="properties[__flare]"]'
    );
    const flareDeliveryDateInput = document.querySelector(
      'input[name="properties[__flare_delivery_date]"]'
    );

    const formattedDeliveryDate = formattedDeliveryDateInput
      ? formattedDeliveryDateInput.value
      : null;
    const flareDelivery = flareDeliveryInput ? flareDeliveryInput.value : null;
    const flareDeliveryDate = flareDeliveryDateInput
      ? flareDeliveryDateInput.value
      : null;

    // v18: on a product on the basket's date picker, the date the basket would pick goes on every line when the
    // basket was empty (assets/mj-express.js checks the whole basket once the lines are in)
    const mjx = window.MJExpress;
    const mjDate = mjx ? mjx.predictFromPage(mainVariantId) : null;

    if (!mainAddToCartBtn) return;
    mainAddToCartBtn.disabled = true;

    const loader = mainAddToCartBtn.querySelector(".ajax-loader");
    const cartTitle = mainAddToCartBtn.querySelector(".cart-title");
    const cartTitleText = cartTitle ? cartTitle.textContent : "";
    if (loader) loader.style.display = "block";
    if (cartTitle) cartTitle.style.display = "none";

    try {
      const itemsToAdd = [];
      const uniqueId = generateUniqueId();
      const allSelectedAddons = [];

      // Collect all selected addons
      addonGroupsNew.forEach((groupData, groupIndex) => {
        if (groupData.type === "drawer") {
          // Drawer mode - multiple categories
          Object.entries(groupData.categorySelections).forEach(
            ([categoryIndex, selection]) => {
              if (selection.variantId) {
                allSelectedAddons.push({
                  groupIndex: groupIndex,
                  categoryIndex: parseInt(categoryIndex),
                  categoryTitle: selection.categoryTitle,
                  variantId: selection.variantId,
                  price: selection.price,
                  title: selection.title,
                });
              }
            }
          );
        } else if (groupData.type === "simple") {
          // Simple mode - checkbox or radio
          groupData.selectedVariants.forEach((variant) => {
            allSelectedAddons.push({
              groupIndex: groupIndex,
              categoryIndex: null, // No category in simple mode
              categoryTitle: null,
              variantId: variant.variantId,
              price: variant.price,
              title: variant.title,
            });
          });
        }
      });

      // Extras outside the upsell groups (the matching protector on the mattress page)
      const mjExtras = getMjExtraAddons();
      lastMjExtras = mjExtras;
      mjExtras.forEach((extra) => {
        allSelectedAddons.push({
          groupIndex: null,
          categoryIndex: null,
          categoryTitle: extra.categoryTitle,
          variantId: extra.variantId,
          price: extra.price,
          title: extra.title,
          source: extra.source,
        });
      });

      // Main product properties
      const mainProductProperties = {
        _product_group_id: uniqueId,
        _is_upsell: allSelectedAddons.length > 0 ? "true" : "false",
        _upsell_for: null,
        _upsell_to:
          allSelectedAddons.length > 0
            ? allSelectedAddons.map((a) => a.variantId).join(",")
            : null,
      };

      if (formattedDeliveryDate && flareDelivery && flareDeliveryDate) {
        mainProductProperties["Delivery Date"] = formattedDeliveryDate;
        mainProductProperties["__flare"] = flareDelivery;
        mainProductProperties["__flare_delivery_date"] = flareDeliveryDate;
      }
      if (mjDate && !mainProductProperties["Delivery Date"]) mainProductProperties["Delivery Date"] = mjDate;

      itemsToAdd.push({
        id: mainVariantId,
        quantity: quantity,
        properties: mainProductProperties,
      });

      // Add all addons with category tracking
      allSelectedAddons.forEach((addon) => {
        const addonProperties = {
          _product_group_id: uniqueId,
          _is_upsell: "true",
          _upsell_for: mainVariantId,
          _upsell_to: null,
          _addon_group_index: addon.groupIndex,
          _addon_category_index: addon.categoryIndex,
          _addon_category_title: addon.categoryTitle,
          // Order-tracking: which A/B branch + device the addon was added from,
          // and which main-product variant it was attached to. Underscore-prefixed
          // = hidden from the customer at checkout, still in the order admin/exports.
          _upsell_source: addon.source
            ? addon.source +
              (window.matchMedia("(max-width: 991px)").matches
                ? "_mobile"
                : "_desktop")
            : upsellSource,
          _upsell_main_variant_id: mainVariantId,
          _upsell_main_variant_title: mainVariantTitle,
        };

        if (formattedDeliveryDate && flareDelivery && flareDeliveryDate) {
          addonProperties["Delivery Date"] = formattedDeliveryDate;
          addonProperties["__flare"] = flareDelivery;
          addonProperties["__flare_delivery_date"] = flareDeliveryDate;
        }
        if (mjDate && !addonProperties["Delivery Date"]) addonProperties["Delivery Date"] = mjDate;

        itemsToAdd.push({
          id: addon.variantId,
          quantity: quantity,
          properties: addonProperties,
        });
      });

      // Add to cart
      const response = await fetch("/cart/add.json", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(mjx ? { items: itemsToAdd, sections: mjx.SECTION } : { items: itemsToAdd }),
      });

      if (response.ok) {
        const addedItems = await response.json();

        // Refresh cart
        if (typeof window.refreshCart === "function") {
          window.refreshCart();
        } else {
          await updateCartCounter();
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:update"));

        showSuccessPopup(itemsToAdd, addedItems);

        // Untick the extras so a second click doesn't add them again
        lastMjExtras.forEach((extra) => {
          extra.input.checked = false;
          extra.input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        setTimeout(() => {
          mainAddToCartBtn.disabled = false;
          if (loader) loader.style.display = "none";
          if (cartTitle) cartTitle.style.display = "block";
        }, 2000);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      if (cartTitle) cartTitle.textContent = "Please try again";
      mainAddToCartBtn.disabled = false;
      if (loader) loader.style.display = "none";
      setTimeout(() => {
        if (cartTitle) {
          cartTitle.textContent = cartTitleText || "Add to basket";
          cartTitle.style.display = "block";
        }
      }, 3000);
    }
  }

  async function updateCartCounter() {
    try {
      const response = await fetch("/cart.json");
      if (response.ok) {
        const cartData = await response.json();
        const cartCountElement = document.querySelector(
          '.ajax-cart-count span[aria-hidden="true"]'
        );
        const cartCountVisuallyHidden = document.querySelector(
          ".ajax-cart-count .visually-hidden"
        );

        if (cartCountElement && cartData.item_count < 100) {
          cartCountElement.textContent = cartData.item_count;
        }
        if (cartCountVisuallyHidden) {
          cartCountVisuallyHidden.textContent = `Cart ${cartData.item_count}`;
        }

        const cartCountContainer = document.querySelector(".ajax-cart-count");
        if (cartCountContainer) {
          cartCountContainer.style.display =
            cartData.item_count > 0 ? "block" : "none";
        }
      }
    } catch (error) {
      console.error("Error updating cart counter:", error);
    }
  }

  // ============================================================================
  // SUCCESS POPUP
  // ============================================================================

  function showSuccessPopup(itemsAdded, responseData) {
    const popupHTML = `
      <div class="success-popup-overlay">
        <div class="success-popup">
          <div class="success-popup-header">
            <div class="success-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" fill="#22c55e"/>
                <path d="m9 12 2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>Added to your basket</h3>
            <button class="success-popup-close">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="success-popup-content">
            <div class="added-products" id="addedProductsList"></div>
          </div>
          <div class="success-popup-footer">
            <button class="continue-shopping-btn">Keep shopping</button>
            <a class="view-cart-btn" href="/cart">View basket</a>
            <a class="checkout-cart-btn" href="/checkout">Checkout</a>
          </div>
          <div class="success-popup-express" data-mj-express hidden>
            <p class="success-popup-or"><span>or pay now</span></p>
            <div class="success-popup-wallets" data-mj-express-wallets></div>
            <p class="success-popup-date" data-mj-express-date hidden></p>
          </div>
        </div>
      </div>
    `;

    const existingPopup = document.querySelector(".success-popup-overlay");
    if (existingPopup) existingPopup.remove();

    document.body.insertAdjacentHTML("beforeend", popupHTML);
    populateProductsList(itemsAdded);

    setTimeout(() => {
      const popup = document.querySelector(".success-popup-overlay");
      if (popup) popup.classList.add("active");
    }, 100);

    setupPopupEventListeners();

    // v18 (assets/mj-express.js): the basket's own express buttons once the basket has the delivery date its
    // picker would hold. Checkout skips the basket, so it gives the basket that date first, and goes to the
    // basket instead when it can't be sure of it.
    const mjx = window.MJExpress;
    const popup = document.querySelector(".success-popup-overlay");
    if (mjx && popup) {
      mjx.afterAdd(responseData && responseData.sections && responseData.sections[mjx.SECTION], {
        root: popup.querySelector("[data-mj-express]"),
        wallets: popup.querySelector("[data-mj-express-wallets]"),
        note: popup.querySelector("[data-mj-express-date]"),
      });
      const checkoutLink = popup.querySelector(".checkout-cart-btn");
      if (checkoutLink) {
        checkoutLink.addEventListener("click", function (event) {
          event.preventDefault();
          if (checkoutLink.getAttribute("aria-busy") === "true") return;
          checkoutLink.setAttribute("aria-busy", "true");
          mjx.ensure(6000).then(function (res) {
            window.location.href = res && res.ok ? "/checkout" : "/cart";
          });
        });
      }
    }
  }

  function populateProductsList(itemsAdded) {
    const productsList = document.getElementById("addedProductsList");
    if (!productsList) return;

    try {
      const currentProductTitle =
        document.querySelector(".product-title, h1")?.textContent?.trim() ||
        "Bed";
      const currentProductPrice = document
        .querySelector("#ProductPrice")
        ?.textContent?.trim();
      const currentProductImage =
        document.querySelector(".product-media img")?.src ||
        document.querySelector(".slider-big img")?.src ||
        "";
      const mainVariantId = document.querySelector('input[name="id"]').value;

      let productsHTML = "";

      for (const item of itemsAdded) {
        if (item.id == mainVariantId) {
          productsHTML += `
            <div class="added-product-item">
              <div class="product-image">
                <img src="${currentProductImage}" alt="${currentProductTitle}" />
              </div>
              <div class="product-details">
                <h4>${currentProductTitle}</h4>
                <p class="product-variant"><span>Size:</span> ${
                  getSelectedVariantTitle() || ""
                }</p>
                <p class="product-quantity"><span>Qty:</span> ${
                  item.quantity
                }</p>
                <p class="product-price">${currentProductPrice}</p>
              </div>
            </div>
          `;
        } else {
          // Find addon info - use properties from cart item first
          let addonInfo = null;

          // Check if item has addon properties with category info
          const categoryIndex = item.properties?._addon_category_index;
          const categoryTitle = item.properties?._addon_category_title;

          addonGroupsNew.forEach((groupData) => {
            if (groupData.type === "drawer") {
              // If we have category index from properties, use it to find the exact match
              if (categoryIndex !== undefined) {
                const selection = groupData.categorySelections[categoryIndex];
                if (selection && selection.variantId == item.id) {
                  const panel = groupData.overlay.querySelector(
                    `.category-tab-panel[data-category-index="${categoryIndex}"]`
                  );
                  if (panel) {
                    const addonCard = panel
                      .querySelector(`input[value="${item.id}"]`)
                      ?.closest(".addon-card-new");
                    if (addonCard) {
                      const title =
                        addonCard.querySelector(".addon-title-new")
                          ?.textContent || "Add-on";
                      const image =
                        addonCard.querySelector(".addon-image-new img")?.src ||
                        "";
                      const price =
                        addonCard.querySelector(".addon-price-new")
                          ?.textContent || "";

                      // Get addon variant name and option type
                      let variantName = "";
                      let variantOptionName = "Size";
                      const variantIds = addonCard.dataset.variantIds
                        ? addonCard.dataset.variantIds.split(",")
                        : [];
                      const variantTitles = addonCard.dataset.addonVariants
                        ? addonCard.dataset.addonVariants.split(",")
                        : [];
                      const variantIndex = variantIds.indexOf(String(item.id));
                      if (variantIndex !== -1 && variantTitles[variantIndex]) {
                        // Extract variant value (before the "/")
                        const extractedName = variantTitles[variantIndex]
                          .split("/")[0]
                          .trim();

                        // Get the variant option name
                        const optionName =
                          addonCard.dataset.variantOptionName || "Size";

                        // Filter out irrelevant variants
                        const irrelevantValues = [
                          "Default Title",
                          "Yes Please",
                          "No Thanks",
                          "Yes",
                          "No",
                        ];
                        const irrelevantOptionNames = ["Title"];

                        if (
                          !irrelevantValues.includes(extractedName) &&
                          !irrelevantOptionNames.includes(optionName)
                        ) {
                          variantName = extractedName;
                          variantOptionName = optionName;
                          // Normalize "Mattress Sizes" to "Size"
                          if (variantOptionName === "Mattress Sizes") {
                            variantOptionName = "Size";
                          }
                        }
                      }

                      addonInfo = {
                        title,
                        image,
                        price,
                        variantName,
                        variantOptionName,
                        categoryTitle: categoryTitle || selection.categoryTitle,
                      };
                    }
                  }
                }
              } else {
                // Fallback: search by variant ID (for backward compatibility)
                Object.values(groupData.categorySelections).forEach(
                  (selection) => {
                    if (selection.variantId == item.id && !addonInfo) {
                      const panel = groupData.overlay
                        .querySelector(`input[value="${item.id}"]`)
                        ?.closest(".category-tab-panel");
                      if (panel) {
                        const addonCard = panel
                          .querySelector(`input[value="${item.id}"]`)
                          ?.closest(".addon-card-new");
                        if (addonCard) {
                          const title =
                            addonCard.querySelector(".addon-title-new")
                              ?.textContent || "Add-on";
                          const image =
                            addonCard.querySelector(".addon-image-new img")
                              ?.src || "";
                          const price =
                            addonCard.querySelector(".addon-price-new")
                              ?.textContent || "";

                          // Get addon variant name and option type
                          let variantName = "";
                          let variantOptionName = "Size";
                          const variantIds = addonCard.dataset.variantIds
                            ? addonCard.dataset.variantIds.split(",")
                            : [];
                          const variantTitles = addonCard.dataset.addonVariants
                            ? addonCard.dataset.addonVariants.split(",")
                            : [];
                          const variantIndex = variantIds.indexOf(
                            String(item.id)
                          );
                          if (
                            variantIndex !== -1 &&
                            variantTitles[variantIndex]
                          ) {
                            // Extract variant value (before the "/")
                            const extractedName = variantTitles[variantIndex]
                              .split("/")[0]
                              .trim();

                            // Get the variant option name
                            const optionName =
                              addonCard.dataset.variantOptionName || "Size";

                            // Filter out irrelevant variants
                            const irrelevantValues = [
                              "Default Title",
                              "Yes Please",
                              "No Thanks",
                              "Yes",
                              "No",
                            ];
                            const irrelevantOptionNames = ["Title"];

                            if (
                              !irrelevantValues.includes(extractedName) &&
                              !irrelevantOptionNames.includes(optionName)
                            ) {
                              variantName = extractedName;
                              variantOptionName = optionName;
                              // Normalize "Mattress Sizes" to "Size"
                              if (variantOptionName === "Mattress Sizes") {
                                variantOptionName = "Size";
                              }
                            }
                          }

                          addonInfo = {
                            title,
                            image,
                            price,
                            variantName,
                            variantOptionName,
                            categoryTitle: selection.categoryTitle,
                          };
                        }
                      }
                    }
                  }
                );
              }
            } else if (groupData.type === "simple") {
              groupData.selectedVariants.forEach((variant) => {
                if (variant.variantId == item.id) {
                  const option = groupData.container
                    .querySelector(`input[data-variant-id="${item.id}"]`)
                    ?.closest(".simple-addon-option-new");
                  if (option) {
                    const title =
                      option.querySelector(".simple-addon-title-new")
                        ?.textContent || "Add-on";
                    const image =
                      option.querySelector(".simple-addon-image-new img")
                        ?.src || "";
                    const price =
                      option.querySelector(".simple-addon-price-new")
                        ?.textContent || "";

                    // Get addon variant name and option type
                    let variantName = "";
                    let variantOptionName = "Size";
                    const variantIds = option.dataset.variantIds
                      ? option.dataset.variantIds.split(",")
                      : [];
                    const variantTitles = option.dataset.addonVariants
                      ? option.dataset.addonVariants.split(",")
                      : [];
                    const variantIndex = variantIds.indexOf(String(item.id));
                    if (variantIndex !== -1 && variantTitles[variantIndex]) {
                      // Extract variant value (before the "/")
                      const extractedName = variantTitles[variantIndex]
                        .split("/")[0]
                        .trim();

                      // Get the variant option name
                      const optionName =
                        option.dataset.variantOptionName || "Size";

                      // Filter out irrelevant variants
                      const irrelevantValues = [
                        "Default Title",
                        "Yes Please",
                        "No Thanks",
                        "Yes",
                        "No",
                      ];
                      const irrelevantOptionNames = ["Title"];

                      if (
                        !irrelevantValues.includes(extractedName) &&
                        !irrelevantOptionNames.includes(optionName)
                      ) {
                        variantName = extractedName;
                        variantOptionName = optionName;
                        // Normalize "Mattress Sizes" to "Size"
                        if (variantOptionName === "Mattress Sizes") {
                          variantOptionName = "Size";
                        }
                      }
                    }

                    addonInfo = {
                      title,
                      image,
                      price,
                      variantName,
                      variantOptionName,
                      categoryTitle: null,
                    };
                  }
                }
              });
            }
          });

          if (!addonInfo) {
            const extra = lastMjExtras.find(
              (e) => String(e.variantId) === String(item.id)
            );
            if (extra) {
              addonInfo = {
                title: extra.title,
                image: extra.image,
                price: formatMoney(extra.price),
                variantName: extra.size,
                variantOptionName: "Size",
                categoryTitle: extra.categoryTitle,
              };
            }
          }

          if (addonInfo) {
            productsHTML += `
              <div class="added-product-item">
                <div class="product-image">
                  <img src="${addonInfo.image}" alt="${addonInfo.title}" />
                </div>
                <div class="product-details">
                  <h4><span>Add-on${
                    addonInfo.categoryTitle
                      ? " (" + addonInfo.categoryTitle + ")"
                      : ""
                  }:</span> ${addonInfo.title}</h4>
                  ${
                    addonInfo.variantName
                      ? `<p class="product-variant"><span>${
                          addonInfo.variantOptionName || "Size"
                        }:</span> ${addonInfo.variantName}</p>`
                      : ""
                  }
                  <p class="product-quantity"><span>Qty:</span> ${
                    item.quantity
                  }</p>
                  <p class="product-price">${addonInfo.price}</p>
                </div>
              </div>
            `;
          }
        }
      }

      productsList.innerHTML = productsHTML;
    } catch (error) {
      console.error("Error populating products list:", error);
      productsList.innerHTML = "<p>Products added successfully!</p>";
    }
  }

  function setupPopupEventListeners() {
    const popup = document.querySelector(".success-popup-overlay");
    const closeBtn = document.querySelector(".success-popup-close");
    const continueBtn = document.querySelector(".continue-shopping-btn");

    function closePopup() {
      if (popup) {
        popup.classList.add("closing");
        popup.remove();
      }
    }

    if (closeBtn) closeBtn.addEventListener("click", closePopup);
    if (continueBtn) continueBtn.addEventListener("click", closePopup);

    if (popup) {
      popup.addEventListener("click", function (e) {
        if (e.target === popup) closePopup();
      });
    }

    const escapeHandler = function (e) {
      if (e.key === "Escape" && popup) {
        closePopup();
        document.removeEventListener("keydown", escapeHandler);
      }
    };
    document.addEventListener("keydown", escapeHandler);
  }

  // ============================================================================
  // EVENT LISTENERS
  // ============================================================================

  // Drawer triggers
  drawerTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const groupIndex = this.dataset.groupIndex;
      const groupData = addonGroupsNew.get(groupIndex);
      if (groupData && groupData.overlay) {
        // Find first unselected category
        const tabPanels = groupData.overlay.querySelectorAll(
          ".category-tab-panel"
        );
        let firstUnselectedIndex = null;

        tabPanels.forEach((panel) => {
          const categoryIndex = panel.dataset.categoryIndex;
          if (
            !groupData.categorySelections[categoryIndex] &&
            firstUnselectedIndex === null
          ) {
            firstUnselectedIndex = categoryIndex;
          }
        });

        // If we found an unselected category, activate it
        if (firstUnselectedIndex !== null) {
          // Activate the tab button
          const tabButtons =
            groupData.overlay.querySelectorAll(".category-tab-btn");
          tabButtons.forEach((btn) => {
            if (btn.dataset.categoryIndex === firstUnselectedIndex) {
              btn.classList.add("active");
            } else {
              btn.classList.remove("active");
            }
          });

          // Activate the tab panel
          tabPanels.forEach((panel) => {
            if (panel.dataset.categoryIndex === firstUnselectedIndex) {
              panel.classList.add("active");
            } else {
              panel.classList.remove("active");
            }
          });
        }

        openDrawer(groupData.overlay);
      }
    });
  });

  // Drawer close
  allDrawerOverlays.forEach((overlay) => {
    overlay.addEventListener("click", function (e) {
      if (
        !e.target.closest(".drawer-content-new") &&
        !e.target.closest(".more-info-new.pop-up")
      ) {
        closeDrawer(this);
      }
    });

    const closeBtn = overlay.querySelector(".drawer-close-new");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        // Inline: the ✕ cancels an in-progress "Change" (collapses back to the
        // selected card). Only falls through to closing a real drawer otherwise.
        if (cancelInlineChange(overlay)) return;
        closeDrawer(overlay);
      });
    }
  });

  // Radio selection in drawers
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"][data-category-index]')) {
      handleDrawerAddonSelection(e.target);
    }
  });

  // Checkbox selection in simple mode
  document.addEventListener("change", function (e) {
    if (e.target.matches(".simple-addon-checkbox")) {
      handleSimpleAddonSelection(e.target);
    }
  });

  // Simple mode remove buttons
  document.addEventListener("click", function (e) {
    if (e.target.closest(".simple-remove-btn-new")) {
      const btn = e.target.closest(".simple-remove-btn-new");
      handleSimpleRemove(btn);
    }
  });

  // Drawer addon card Add button
  document.addEventListener("click", function (e) {
    if (e.target.closest(".addon-select-indicator-new")) {
      const addBtn = e.target.closest(".addon-select-indicator-new");
      const addonCard = addBtn.closest(".addon-card-new");
      if (addonCard) {
        const radioInput = addonCard.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.checked = true;
          handleDrawerAddonSelection(radioInput);
        }
      }
    }
  });

  // "Show More Options" toggle inside a drawer/inline addon list
  document.addEventListener("click", function (e) {
    const showMoreBtn = e.target.closest(".addon-show-more-new");
    if (!showMoreBtn) return;
    e.preventDefault();
    e.stopPropagation();

    const list = showMoreBtn.closest(".product-addons-new");
    const panel = showMoreBtn.closest(".category-tab-panel");
    if (!list || !panel) return;

    // Flip persisted state, then let applyAddonShowMore rebuild from the
    // current visible set (keeps it correct after variant changes).
    const nowExpanded = !list.classList.contains("addon-is-expanded");
    list.classList.toggle("addon-is-expanded", nowExpanded);
    applyAddonShowMore(panel);
  });

  // Re-evaluate show-more when crossing the 991px inline/drawer boundary:
  // collapse when shrinking to inline, clear it when growing back to a drawer.
  const inlineAddonMql = window.matchMedia("(max-width: 991px)");
  const reapplyAllAddonShowMore = () => {
    document
      .querySelectorAll(".drawer-group-container-new .category-tab-panel")
      .forEach((panel) => applyAddonShowMore(panel));
  };
  if (inlineAddonMql.addEventListener) {
    inlineAddonMql.addEventListener("change", reapplyAllAddonShowMore);
  } else if (inlineAddonMql.addListener) {
    // Safari < 14 fallback
    inlineAddonMql.addListener(reapplyAllAddonShowMore);
  }

  // Variant selector changes
  if (variantSelectors.length > 0) {
    variantSelectors.forEach((selector) => {
      selector.addEventListener("change", function () {
        const selectedVariantTitle = getSelectedVariantTitle();
        if (currentVariantTitle !== selectedVariantTitle) {
          currentVariantTitle = selectedVariantTitle;

          // Update all drawer groups
          addonGroupsNew.forEach((groupData, groupIndex) => {
            if (groupData.type === "drawer") {
              updateAllCategoriesForGroup(groupIndex);
            } else if (groupData.type === "simple") {
              updateSimpleGroupAddons(groupIndex);
            }
          });
        }
      });
    });
  }

  // Escape key handler
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      const activePopup = document.querySelector(
        ".more-info-new.pop-up.active"
      );
      if (activePopup) {
        activePopup.classList.remove("active");
        document.body.style.overflow = "";
      } else {
        const activeOverlay = document.querySelector(
          ".drawer-overlay-new.active"
        );
        if (activeOverlay) {
          closeDrawer(activeOverlay);
        }
      }
    }
  });

  // Add to cart form
  if (mainProductForm) {
    mainProductForm.addEventListener("submit", handleCombinedAddToCart);
  }

  if (mainAddToCartBtn) {
    mainAddToCartBtn.addEventListener("click", function (e) {
      if (mainProductForm) {
        e.preventDefault();
        handleCombinedAddToCart(e);
      }
    });
  }

  // ============================================================================
  // INITIALIZE
  // ============================================================================

  initializeAddonGroups();
  setupTabSwitching();
  setupMoreInfoButtons();
  setupMoreInfoCloseButtons();
  setupClearButtons();

  currentVariantTitle = getSelectedVariantTitle();

  // Initial update
  addonGroupsNew.forEach((groupData, groupIndex) => {
    if (groupData.type === "drawer") {
      updateAllCategoriesForGroup(groupIndex);
    } else if (groupData.type === "simple") {
      updateSimpleGroupAddons(groupIndex);
    }
  });

  // Expose to window for debugging
  window.addonGroupsNew = addonGroupsNew;
  window.handleCombinedAddToCart = handleCombinedAddToCart;
});
